export enum EQuizMode {
  QUIZ = 'QUIZ',
  PRACTICE = 'PRACTICE',
  TRUE_FALSE = 'TRUE_FALSE',
  PRACTICAL_CASE = 'PRACTICAL_CASE',
  LIGHTNING = 'LIGHTNING'
}

export const EQuizModeEmojiIcon = {
  [EQuizMode.QUIZ]: '🎯',
  [EQuizMode.LIGHTNING]: '⚡️',
  [EQuizMode.TRUE_FALSE]: '🏓',
  [EQuizMode.PRACTICE]: '⏳',
  [EQuizMode.PRACTICAL_CASE]: '📋'
};

export const QUIZ_MODES = Object.values(EQuizMode);

export enum EQuizStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export enum EQuizDifficulty {
  EASY = 'EASY',
  MEDIUM = 'MEDIUM',
  HARD = 'HARD'
}

const QUIZ_TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/1Jf9ruZmWCe16gjvNMNsTBq69L-5WFy2lGV7GNEd0_mM/edit?gid=0#gid=0';
const PRACTICE_TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/1H3HzLq73aoGFjJarPgo_wie9JL3JenvyGSPIcTf4kuw/edit?gid=1605823565#gid=1605823565';

const TRUE_FALSE_TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/1-WP2sKIHz1Qr8xOmiAOCbM_NZX3cMkplZnESIjlJzbQ/edit?gid=824566737#gid=824566737';

const PRACTICAL_CASE_TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/1rZi0GKVMP_htTWFNPk8J3pLoeWuHTZauuUdzrI9ZSmk/edit?gid=216081731#gid=216081731';

export const MODE_TEMPATES = {
  [EQuizMode.QUIZ]: QUIZ_TEMPLATE_URL,
  [EQuizMode.PRACTICE]: PRACTICE_TEMPLATE_URL,
  [EQuizMode.TRUE_FALSE]: TRUE_FALSE_TEMPLATE_URL,
  [EQuizMode.PRACTICAL_CASE]: PRACTICAL_CASE_TEMPLATE_URL,
  [EQuizMode.LIGHTNING]: QUIZ_TEMPLATE_URL
};

export enum EGenerateQuizQuestionOptions {
  NEW = 'NEW',
  WRONGS = 'WRONGS',
  BLANKS = 'BLANKS'
}

export enum EQuizCorrectionMode {
  CORRECT_INSTANTLY = 'CORRECT_INSTANTLY',
  CORRECT_ON_REVIEW = 'CORRECT_ON_REVIEW'
}

export const MODE_FILTER_MAP = {
  [EQuizMode.QUIZ]: [EQuizMode.QUIZ, EQuizMode.PRACTICE],
  [EQuizMode.PRACTICE]: [EQuizMode.PRACTICE],
  [EQuizMode.PRACTICAL_CASE]: [EQuizMode.PRACTICAL_CASE],
  [EQuizMode.TRUE_FALSE]: [EQuizMode.TRUE_FALSE],
  [EQuizMode.LIGHTNING]: [EQuizMode.QUIZ, EQuizMode.PRACTICE, EQuizMode.TRUE_FALSE]
};

